import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridButton, GridLibAngularComponentModule } from '@gen-nexus-registry/grid-lib-angular/dist/grid-lib-angular-component';
import { TranslateModule } from '@ngx-translate/core';
import { ESectionTitle } from 'src/model/enum/sic-ania/section.title.enum';
import { StaticSummaryDataComponent } from '../shared-components/static-summary-data/static-summary-data.component';
import { ICopertura } from 'src/model/responses/sic-ania/sita.response';
import { UtilityService } from 'src/api/utility.service';
import { atrcSectionSummary, sitaSectionSummary, siviSectionSummary } from 'src/model/constants/constants';

@Component({
  selector: 'app-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.scss'],
  standalone: true,
  imports: [GridLibAngularComponentModule, CommonModule, TranslateModule, StaticSummaryDataComponent]
})
export class SummaryCardComponent implements OnInit {
  sectionSummary: any;

  @Input()
  sectionTitle?: string;

  @Input()
  sectionData?: any;

  @Input()
  sectionDetails?: any;

  @ViewChild('gridButton') gridButton?: GridButton;

  isDisabled = false;

  constructor(public utilityService: UtilityService) {}

  ngOnInit() {
    let coperture: ICopertura[];
    switch (this.sectionTitle) {
      case ESectionTitle.SIVI:
        this.sectionSummary = siviSectionSummary;
        break;
      case ESectionTitle.SITA:
        coperture = this.sectionDetails[this.sectionTitle].dropDownData[this.sectionTitle + 'DropDownData']?.coperture;
        this.setCompanyNumber(coperture);
        this.sectionSummary = sitaSectionSummary;
        break;
      case ESectionTitle.ATRC:
        this.sectionSummary = atrcSectionSummary;
        break;
      default:
    }
  }

  ngAfterViewInit(){
    if(Object.keys(this.sectionDetails[this.sectionTitle!].accordionData).length === 0){
      this.gridButton!.gridDisabled = true;
    }
  }

  titleEmitter(e: any) {
    this.utilityService.emitSectionTitleSubject.next(e.target.id);
  }

  private setCompanyNumber(coperture: ICopertura[]) {
    const impreseDb: number[] = [];
    coperture?.forEach((copertura) => {
      if (impreseDb.length === 0 || !impreseDb.some((impresa) => impresa === copertura.impresaDb)) impreseDb.push(copertura.impresaDb);
    });
    this.sectionData.numCompCopertura = impreseDb.length;
  }
}
